"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _asyncCompose = _interopRequireDefault(require("./utils/asyncCompose"));
var _resolveSvg = _interopRequireDefault(require("./steps/resolveSvg"));
var _resolveZIndex = _interopRequireDefault(require("./steps/resolveZIndex"));
var _resolveAssets = _interopRequireDefault(require("./steps/resolveAssets"));
var _resolveStyles = _interopRequireDefault(require("./steps/resolveStyles"));
var _resolveOrigins = _interopRequireDefault(require("./steps/resolveOrigins"));
var _resolvePageBalancing = _interopRequireDefault(require("./steps/resolvePageBalancing"));
var _resolvePageSizes = _interopRequireDefault(require("./steps/resolvePageSizes"));
var _resolvePagination = _interopRequireDefault(require("./steps/resolvePagination"));
var _resolveDimensions = _interopRequireDefault(require("./steps/resolveDimensions"));
var _resolveTextLayout = _interopRequireDefault(require("./steps/resolveTextLayout"));
var _resolveInheritance = _interopRequireDefault(require("./steps/resolveInheritance"));
var _resolvePagePaddings = _interopRequireDefault(require("./steps/resolvePagePaddings"));
var _resolvePercentRadius = _interopRequireDefault(require("./steps/resolvePercentRadius"));
var _resolvePercentHeight = _interopRequireDefault(require("./steps/resolvePercentHeight"));
var _resolveLinkSubstitution = _interopRequireDefault(require("./steps/resolveLinkSubstitution"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// const startTimer = name => R.tap(() => console.time(name));
// const endTimer = name => R.tap(() => console.timeEnd(name));

var DISABLE_LOGS = true;
var lastStage;
var logStatus = function logStatus(stage, end) {
  return R.tap(function (doc) {
    if (DISABLE_LOGS) {
      return;
    }
    if (lastStage) {
      console.timeEnd(lastStage);
      console.groupEnd();
    }
    if (end) {
      return;
    }
    console.group(stage);
    console.log('INPUT:');
    console.log(doc);
    console.time(stage);
    lastStage = stage;
  });
};
var layout = (0, _asyncCompose.default)(logStatus('end', true), _resolveZIndex.default, logStatus('resolveZIndex'), _resolveOrigins.default, logStatus('resolveOrigins'), _resolvePageBalancing.default, logStatus('resolvePageBalancing'), _resolvePagination.default, logStatus('resolvePagination'), _resolveTextLayout.default, logStatus('resolveTextLayout'), _resolvePercentRadius.default, logStatus('resolvePercentRadius'), _resolveDimensions.default, logStatus('resolveDimensions'), _resolveSvg.default, logStatus('resolveSvg'), _resolveAssets.default, logStatus('resolveAssets'), _resolveInheritance.default, logStatus('resolveInheritance'), _resolvePercentHeight.default, logStatus('resolvePercentHeight'), _resolvePagePaddings.default, logStatus('resolvePagePaddings'), _resolveStyles.default, logStatus('resolveStyles'), _resolveLinkSubstitution.default, logStatus('resolveLinkSubstitution'), _resolvePageSizes.default, logStatus('resolvePageSizes'));
var _default = exports.default = layout;